<template>
    <custom-rich-marker :marker="marker">
        <div class="status-item-pin">
            <div class="status-item-pin-icon" :class="iconClass" />
            <div class="status-item-pin-count">{{ marker.count }}</div>
        </div>
    </custom-rich-marker>
</template>

<script>
    import CustomRichMarker from '../Maps/CustomRichMarker';

    export default {
        components: { CustomRichMarker },
        props: {
            marker: {
                type: Object,
                required: true,
            },
        },
        computed: {
            iconClass() {
                return 'is-' + this.marker.status;
            },
        },
    };
</script>